import { useEffect } from 'react'

import useCollapsedSidebar from './useCollapsedSidebar'

/**
 * Shared lifecycle effects for both accumulation and spending home variants.
 * Each variant handles its own data fetching because they load different cases.
 */
export default function useHomeLifecycle({
  navigate,
  onBoarded,
  spendDownModeling,
  disableSpendDownModeling,
  hasStripeSessionId,
  retailLinkAccount,
  deleteStripeSessionId,
  sidebarActive,
  toggleSidebar,
  expandSidebar,
}) {
  // Mounting home exits a temporary spend-down modeling session.
  useEffect(() => {
    if (spendDownModeling) {
      disableSpendDownModeling()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!onBoarded) {
      navigate('/welcome', { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onBoarded])

  // When a retail user returns from Stripe checkout, finish linking the account
  // and clear the session ID so the checkout is not processed again.
  useEffect(() => {
    const handleRetailLinkAccount = async () => {
      if (hasStripeSessionId) {
        try {
          await retailLinkAccount()
          deleteStripeSessionId()
        } catch (err) {
          console.error(err)
        }
      }
    }
    handleRetailLinkAccount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useCollapsedSidebar({ sidebarActive, toggleSidebar, expandSidebar })
}
